<template>
  <page @click="() => batchSetData = ''">
    <module :title="id ? '编辑UNI-APP版本' : '添加UNI-APP版本'">
        <c-form ref="form">
          <c-form-item type="hidden" name="id"></c-form-item>
          <c-form-item type="radio" v-model="appTypeDate" label="所属项目" name="app_type" :options="appTypeName" required></c-form-item>
          <c-form-item type="input" label="版本号" name="version" required word="版本号只能包含数字、小数点，例如：1.0.3"></c-form-item>
          <c-form-item type="file" label="上传文件" name="download_url" file-word="请选择uni-app文件"></c-form-item>
          <c-form-item type="textarea" label="更新内容" name="remark" required></c-form-item>
          <c-form-item type="select" label="最小IOS版本" name="min_ios_version" :options="iosAPPVersions" required></c-form-item>
          <c-form-item type="select"  label="最小Andriod版本" name="min_andriod_version" :options="androidAPPVersions" required></c-form-item>
        </c-form>
      <template slot="button">
        <c-button size="m" @click="submit(2)">提交保存</c-button>
      </template>
    </module>
  </page>
</template>

<script>
export default {
  name: 'uniapp_version_edit',
  data() {
    return {
           version_r: true,
           version_code_r: true,
           version_word: '安装包上传后自动填充',
           systemTypeName: [
                {name: 'IOS',value: 'IOS'},
                {name: 'Android',value: 'ANDROID'}
           ],
           versionTypeName: [
                {name: '内测',value:1},
                {name: '公测',value: 2}
           ],
           appTypeName: [
                {name: '批发平台APP',value:10}
           ],
           appTypeDate:10,
           iosAPPVersions:[],
           androidAPPVersions:[]
    }
  },
  props: {
    id: String
  },
  computed: {

  },

  watch: {
    id() {
        this.getDetail();
    },
    appTypeDate(val){
        this.iosAPPVersions = [];
        this.androidAPPVersions = [];
    }
  },

  mounted() {
      this.initAPPVersion('ios');
      this.initAPPVersion('android');
  },
  methods: {
    initAPPVersion(system) {
      this.request({
        url: '/app/version/option',
        data: {
          system:system,
          app_type:this.appTypeDate,
        },
        success: data => {
          if ('ios' == system){
                this.iosAPPVersions = Array.from(data, item => {
                  return {
                    name: item.version,
                    value: item.version
                  }
                });
          }else {
              this.androidAPPVersions = Array.from(data, item => {
                return {
                  name: item.version,
                  value: item.version
                }
              });
          }
          if (this.id && this.iosAPPVersions.length > 0 && this.androidAPPVersions.length > 0){
              this.getDetail();
          }
        }
      });
    },
    /**加载详情**/
    getDetail() {
      this.request({
        url:'/uni_app_version/detail',
        data: {
          version_id: this.id
        },
        loading: true,
        success: data => {
          this.$refs.form.set(data);
        }
      });
    },
    /**上传完成，解析UNI-APP信息**/
    recognitionAPP() {
      this.request({
        url:'/app/version/info',
        data: {
          url_path: this.appFileUrl
        },
        loading: true,
        success: data => {
            this.$refs.form.set(data);
        }
      });
    },
    /*****提交数据******/
    submit() {
          this.$refs.form.submit({
            url: (this.id && this.id > 0) ? '/uni_app_version/edit' : '/uni_app_version/add',
            rule: {
                app_type: '请选择所属项目',
                version: '请填写 uni-app版本号',
                download_url: '请上传uni-app附件',
                remark: '请填写更新内容',
                min_ios_version: '请选择IOS最小版本号',
                min_andriod_version: '请选择ANDRIOD最小版本号'
            },
            success: (data, res) => {
              this.$message({
                text: '保存成功'
              });
              //刷新列表
              this.$bus.$emit('uniapp_version_list.update', {});
              //关闭当前页面
              this.redirectTo('/uni_app_version');
            }
          });
    }
  }
}
</script>